import * as React from 'react';

import { TContext } from '../types/context';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const context = React.createContext<TContext>(null as any);
